import React, { FC, ReactElement, useContext, useState } from 'react'
import styled, { ThemeContext } from 'styled-components'

import TopQuestionArrow from 'components/GlobalStyles/TopQuestionArrow'

const Container = styled.div`
  display: flex;
  gap: 36px;
`

const ColumnOne = styled.div`
  flex-grow: 1;
`

const ColumnTwo = styled.div``

const PanelTitleContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  flex-direction: row;
`

const DropdownIconContainer = styled.div`
  cursor: pointer;
`

interface ITextColor {
  textColor: string | undefined
}
const Title = styled.div<ITextColor>`
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  ${props => (props.textColor ? `color: ${props.textColor};` : '')}
  white-space: nowrap;
`

interface IHeight {
  height: string
}
const PanelContent = styled.div<IHeight>`
  overflow: hidden;
  height: ${props => props.height};
`

interface IProps {
  title: string | JSX.Element
  children: ReactElement<any, any> | null
  titleColor?: string
  expandCustomIcon?: JSX.Element
  collapseCustomIcon?: JSX.Element
  onExpandToggle?: (expand: boolean) => void
  offsetDropdownIcon?: boolean
  open?: boolean
}

const CollapsiblePanel: FC<IProps> = ({
  title,
  children,
  titleColor,
  expandCustomIcon,
  collapseCustomIcon,
  offsetDropdownIcon,
  onExpandToggle,
  open,
}) => {
  const theme = useContext(ThemeContext)
  const [expand, setExpand] = useState(open)

  const handleToggleExpand = () => {
    setExpand(!expand)
    if (onExpandToggle) onExpandToggle(!expand)
  }

  const renderDropdownIcon = () => (
    <DropdownIconContainer onClick={handleToggleExpand}>
      {(!expandCustomIcon || !collapseCustomIcon) && (
        <TopQuestionArrow
          rotated={expand}
          fill={theme.colors.white}
          strokecap="rounded"
          noSpacer
        />
      )}
      {expand ? expandCustomIcon : collapseCustomIcon}
    </DropdownIconContainer>
  )

  return (
    <Container>
      <ColumnOne>
        <PanelTitleContainer onClick={handleToggleExpand}>
          {typeof title === 'string' ? <Title textColor={titleColor}>{title}</Title> : title}
          {!offsetDropdownIcon && renderDropdownIcon()}
        </PanelTitleContainer>
        <PanelContent height={expand ? 'auto' : '0'}>{children}</PanelContent>
      </ColumnOne>
      {offsetDropdownIcon && <ColumnTwo>{renderDropdownIcon()}</ColumnTwo>}
    </Container>
  )
}

export default CollapsiblePanel
